import { BaseApi } from 'src/api/BaseApi';
import { DEMO_EXPERTS } from 'src/api/demo/experts';

class ExpertApi extends BaseApi {
  async getExperts() {
    if (this.isDemo()) return DEMO_EXPERTS;

    const response = await this.postRequest('experts');

    return response.data;
  }

  async createExpert(data) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        id: Date.now(),
        expert: { ...data, id: Date.now(), valid: 1 },
      });
    }

    const formData = this.createFormData({
      ...data,
      valid: 1,
    });
    const response = await this.postRequest('experts/create', formData);
    return response.data;
  }

  async updateExpert(expertID, data) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        expertID,
        expert: { ...data, expertID },
      });
    }

    const formData = this.createFormData({
      ...data,
      expertID,
    });

    const response = await this.postRequest('experts/update', formData);
    return response.data;
  }

  async requestUpdate() {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        newExperts: 0,
      });
    }

    const response = await this.postRequest('experts/pullnew');
    return response.data;
  }

  async removeExpert(expertID) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        expertID,
        deleted: true,
      });
    }

    const formData = this.createFormData({
      expertID,
    });

    const response = await this.postRequest('experts/delete', formData);
    return response.data;
  }
}

export const expertApi = new ExpertApi();
